import React, { useState } from "react";
import {
  convertThenFormat,
  formatDateTime,
  formatDateTimezon,
} from "../../common-data/Converts";
import UTMParams from "../../lead-management/raw-leads/UTMParams";
import { CheckCircleIcon, XCircleIcon } from "../../../images/icons/icons";
import LeadTimeline from "../../lead-management/lead-revamp-v2/LeadTimeline";

const tabList = ["Lead Details", "Lead Timeline"];

const ViewDetails = ({ rowData, from, userInfoData, isTimeline }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [expanded, setExpanded] = useState({});

  const toggleExpand = (idx) => {
    setExpanded((prev) => ({ ...prev, [idx]: !prev[idx] }));
  };

  const {
    converted_date,
    converted_plan_name,
    converted_plan_price,
    source_name,
  } = rowData || {};

  const dateTime = converted_date ? converted_date?.split(" ") : null;

  const datePart = dateTime ? dateTime?.[0] : "";
  const timePart = dateTime ? dateTime?.[1] + " " + dateTime?.[2] : "";

  const sourceName =
    source_name?.replace(/ /g, "_")?.toLowerCase() === "wtf_one_day_plan"
      ? "WTF One Day Plan"
      : source_name?.replace(/_/g, " ");

  return (
    <>
      {!isTimeline ? (
        <>
          <div className="lms-v2-tabs-container mt15">
            {tabList.map((tab, idx) => (
              <div
                key={tab}
                className={`lms-v2-tab${
                  activeTab === idx ? " lms-v2-tab-active" : ""
                }`}
                onClick={() => setActiveTab(idx)}
                style={{ cursor: "pointer" }}
              >
                {tab}
              </div>
            ))}
          </div>

          {activeTab === 0 && (
            <>
              <div className="user-profile-container staff-onboarding-detail-modal">
                <div className="user-profile-details">
                  {from === "odm" || from === "recurring" ? (
                    <>
                      <div className="user-details">
                        <div className="user-details-head">
                          <p className="head-name">
                            Subscription Start/Expire Date
                          </p>
                        </div>
                        <div className="user-details-info">
                          <p className="info-name">
                            {rowData?.start_date
                              ? formatDateTimezon(rowData.start_date)
                              : "-"}{" "}
                            -{" "}
                            {rowData?.expire_date
                              ? formatDateTimezon(rowData.expire_date)
                              : "-"}
                          </p>
                        </div>
                      </div>

                      <div className="user-details">
                        <div className="user-details-head">
                          <p className="head-name">preferred slot</p>
                        </div>
                        <div className="user-details-info">
                          <p className="info-name">
                            {rowData?.preferred_slot || "-"}
                          </p>
                        </div>
                      </div>

                      <div className="user-details">
                        <div className="user-details-head">
                          <p className="head-name">city</p>
                        </div>
                        <div className="user-details-info">
                          <p className="info-name">{rowData?.city || "-"}</p>
                        </div>
                      </div>

                      {from === "odm" && (
                        <div className="user-details">
                          <div className="user-details-head">
                            <p className="head-name">converted plan</p>
                          </div>
                          <div className="user-details-info">
                            <p className="info-name">
                              {converted_plan_price
                                ? `₹${convertThenFormat(
                                    converted_plan_price || 0
                                  )}`
                                : ""}
                              <br />
                              <small>
                                {converted_plan_name?.replace(/_/g, " ") || "-"}
                              </small>
                              {datePart && timePart && (
                                <>
                                  <br />
                                  {datePart}
                                  <br />
                                  {timePart}
                                </>
                              )}
                            </p>
                          </div>
                        </div>
                      )}
                    </>
                  ) : null}

                  {from === "wati" ? (
                    <>
                      <div className="user-details">
                        <div className="user-details-head">
                          <p className="head-name">keyword name</p>
                        </div>
                        <div className="user-details-info">
                          <p className="info-name">
                            {rowData?.keyword_name || "NA"}
                          </p>
                        </div>
                      </div>

                      <div className="user-details">
                        <div className="user-details-head">
                          <p className="head-name">tab name</p>
                        </div>
                        <div className="user-details-info">
                          <p className="info-name">
                            {rowData?.tab_name || "NA"}
                          </p>
                        </div>
                      </div>

                      <div className="user-details">
                        <div className="user-details-head">
                          <p className="head-name">sheet name</p>
                        </div>
                        <div className="user-details-info">
                          <p className="info-name">
                            {rowData?.sheet_name || "NA"}
                          </p>
                        </div>
                      </div>

                      <div className="user-details">
                        <div className="user-details-head">
                          <p className="head-name">sheet ID</p>
                        </div>
                        <div className="user-details-info">
                          <p className="info-name text-initial">
                            {rowData?.sheet_id || "-"}
                          </p>
                        </div>
                      </div>

                      <div className="user-details">
                        <div className="user-details-head">
                          <p className="head-name">message</p>
                        </div>
                        <div className="user-details-info">
                          <p className="info-name">
                            {rowData?.message || "NA"}
                          </p>
                        </div>
                      </div>

                      <div className="user-details">
                        <div className="user-details-head">
                          <p className="head-name">Added to LMS</p>
                        </div>
                        <div className="user-details-info">
                          <p className="info-name">
                            {rowData?.added_to_lead ? (
                              <CheckCircleIcon />
                            ) : (
                              <XCircleIcon />
                            )}
                          </p>
                        </div>
                      </div>

                      {rowData?.added_to_lead && (
                        <>
                          <div className="user-details">
                            <div className="user-details-head">
                              <p className="head-name">from wati to LMS</p>
                            </div>
                            <div className="user-details-info">
                              <p className="info-name">
                                {rowData?.added_on_lead
                                  ? formatDateTimezon(rowData.added_on_lead)
                                  : "-"}{" "}
                                ({rowData?.add_to_lms_time_dif || "-"})
                              </p>
                            </div>
                          </div>

                          <div className="user-details">
                            <div className="user-details-head">
                              <p className="head-name">
                                from LMS to First follow-up
                              </p>
                            </div>
                            <div className="user-details-info">
                              <p className="info-name">
                                {rowData?.added_on_first_follow_up || ""}
                              </p>
                            </div>
                          </div>

                          <div className="user-details">
                            <div className="user-details-head">
                              <p className="head-name">lead status</p>
                            </div>
                            <div className="user-details-info">
                              <p className="info-name">
                                {rowData?.lead_status?.replace(/_/g, " ") ||
                                  "NA"}
                              </p>
                            </div>
                          </div>

                          <div className="user-details">
                            <div className="user-details-head">
                              <p className="head-name">
                                current follow-up status
                              </p>
                            </div>
                            <div className="user-details-info">
                              <p className="info-name">
                                {rowData?.current_followup_status?.replace(
                                  /_/g,
                                  " "
                                ) || "NA"}
                              </p>
                            </div>
                          </div>
                        </>
                      )}

                      <div className="user-details">
                        <div className="user-details-head">
                          <p className="head-name">conversion</p>
                        </div>
                        <div className="user-details-info">
                          <p className="info-name">
                            {rowData?.is_converted ? (
                              <CheckCircleIcon />
                            ) : (
                              <XCircleIcon />
                            )}
                          </p>
                        </div>
                      </div>

                      {rowData?.converted_plan_name && (
                        <>
                          <div className="user-details">
                            <div className="user-details-head">
                              <p className="head-name">conversion date</p>
                            </div>
                            <div className="user-details-info">
                              <p className="info-name">
                                {rowData?.converted_date
                                  ? formatDateTime(rowData.converted_date)
                                  : "-"}
                              </p>
                            </div>
                          </div>

                          <div className="user-details">
                            <div className="user-details-head">
                              <p className="head-name">converted plan</p>
                            </div>
                            <div className="user-details-info">
                              <p className="info-name">
                                {rowData.converted_plan_name?.replace(
                                  /_/g,
                                  " "
                                ) || "NA"}{" "}
                                (₹
                                {convertThenFormat(
                                  rowData?.converted_plan_price || 0
                                )}
                                )
                              </p>
                            </div>
                          </div>

                          <div className="user-details">
                            <div className="user-details-head">
                              <p className="head-name">plan duration</p>
                            </div>
                            <div className="user-details-info">
                              <p className="info-name">
                                {rowData?.start_date
                                  ? formatDateTime(rowData.start_date)
                                  : "-"}
                                {" - "}{" "}
                                {rowData?.expire_date
                                  ? formatDateTime(rowData.expire_date)
                                  : "-"}
                              </p>
                            </div>
                          </div>
                        </>
                      )}

                      <div className="user-details">
                        <div className="user-details-head">
                          <p className="head-name">assigned agent</p>
                        </div>
                        <div
                          className="user-details-info flex-col"
                          style={{ alignItems: "flex-start" }}
                        >
                          <p className="info-name">
                            {rowData?.assigned_to_name || "NA"}
                          </p>
                          <p className="info-name underline">
                            {rowData?.assigned_to_mobile || ""}
                          </p>
                          <p className="info-name underline lowercase">
                            {rowData?.assigned_to_email || ""}
                          </p>
                        </div>
                      </div>

                      <div className="user-details">
                        <div className="user-details-head">
                          <p className="head-name">keyword name</p>
                        </div>
                        <div className="user-details-info">
                          <p className="info-name">
                            {rowData?.keyword_name || "NA"}
                          </p>
                        </div>
                      </div>
                    </>
                  ) : null}

                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">gender</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name">{rowData?.gender || "-"}</p>
                    </div>
                  </div>

                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">source name</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name">{sourceName || "-"}</p>
                    </div>
                  </div>

                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">gym alias</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name">{rowData?.gym_alias || "-"}</p>
                    </div>
                  </div>

                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">lead from</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name">{rowData?.lead_from || "-"}</p>
                    </div>
                  </div>

                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">Landing Page Name</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name lowercase">
                        {rowData?.keyword || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">visit scheduled</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name">
                        {rowData?.visit_scheduled ? (
                          <CheckCircleIcon />
                        ) : (
                          <XCircleIcon />
                        )}
                      </p>
                    </div>
                  </div>

                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">visit done</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name">
                        {rowData?.visit_done ? (
                          <CheckCircleIcon />
                        ) : (
                          <XCircleIcon />
                        )}
                      </p>
                    </div>
                  </div>

                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">last followup status</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name lowercase">
                        {rowData?.last_follow_up_status?.replace(/_/g, " ") ||
                          "NA"}
                      </p>
                    </div>
                  </div>

                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">current followup status</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name lowercase">
                        {rowData?.current_follow_up_status?.replace(
                          /_/g,
                          " "
                        ) || "NA"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {from === "odm" || from === "recurring" || from === "wati" ? (
                <UTMParams rowData={rowData} />
              ) : null}
            </>
          )}
        </>
      ) : null}

      {isTimeline || activeTab === 1 ? (
        <LeadTimeline
          userInfoData={userInfoData}
          rowData={rowData}
          toggleExpand={toggleExpand}
          expandedItems={expanded}
        />
      ) : null}
    </>
  );
};

export default ViewDetails;
